import { Account } from 'graphql-api/gql-api-interfaces';

// sort accounts that active account and selected accounts are on the top
export function sortAccountsBySelection(
  accounts: Account[],
  selectedAccountIds: string[],
  appliedActiveAccountId = '',
): Account[] {
  return [...accounts].sort((acc1: Account, acc2: Account) => {
    const isFirstActive = acc1.accountId === appliedActiveAccountId;
    const isSecondActive = acc2.accountId === appliedActiveAccountId;

    if (isFirstActive) {
      return -1;
    }

    if (isSecondActive) {
      return 1;
    }

    const isFirstSelected = selectedAccountIds.includes(acc1.accountId);

    const isSecondSelected = selectedAccountIds.includes(acc2.accountId);

    if (isFirstSelected && isSecondSelected) {
      return 0;
    }

    return isFirstSelected ? -1 : 1;
  });
}
